const _temp0 = require("url:./illustrations/default-cover.jpg");

const _temp1 = require("url:./illustrations/full-cloud.png");

const _temp2 = require("url:./illustrations/information.png");


const _temp3 = require("url:./login/cloud.png");

const _temp4 = require("url:./login/dreyfous.png");


const _temp5 = require("url:./logos/dreyfous.png");

const _temp6 = require("url:./logos/edusystem.png");

const _temp7 = require("url:./logos/facebook.png");

const _temp8 = require("url:./logos/instagram.png");

const _temp9 = require("url:./logos/logodry.png");

const _temp10 = require("url:./logos/twitter.png");

const _temp11 = require("url:./logos/youtube.png");


const _temp12 = require("url:./payment-method/9.png");

const _temp13 = require("url:./payment-method/10.png");

const _temp14 = require("url:./payment-method/11.png");

const _temp15 = require("url:./payment-method/13.png");

const _temp16 = require("url:./payment-method/15.png");

const _temp17 = require("url:./payment-method/17.png");

const _temp18 = require("url:./payment-method/18.png");

const _temp19 = require("url:./payment-method/19.png");

const _temp20 = require("url:./payment-method/20.png");

const _temp21 = require("url:./payment-method/21.png");

const _temp22 = require("url:./payment-method/23.png");

const _temp23 = require("url:./payment-method/amazon.png");

const _temp24 = require("url:./payment-method/amex.png");

const _temp25 = require("url:./payment-method/default.png");

const _temp26 = require("url:./payment-method/diners.png");

const _temp27 = require("url:./payment-method/discover.png");

const _temp28 = require("url:./payment-method/jcb.png");

const _temp29 = require("url:./payment-method/maestro.png");

const _temp30 = require("url:./payment-method/mastercard.png");

const _temp31 = require("url:./payment-method/paypal.png");

const _temp32 = require("url:./payment-method/skrill.png");

const _temp33 = require("url:./payment-method/visa.png");

const _temp34 = require("url:./payment-method/westerunion.png");

const _temp35 = require("url:./payment-method/worlpay.png");


module.exports = {
  "illustrations":   {
    "default-cover":     {
      "jpg": _temp0
    },
    "full-cloud":     {
      "png": _temp1
    },
    "information":     {
      "png": _temp2
    }
  },
  "login":   {
    "cloud":     {
      "png": _temp3
    },
    "dreyfous":     {
      "png": _temp4
    }
  },
  "logos":   {
    "dreyfous":     {
      "png": _temp5
    },
    "edusystem":     {
      "png": _temp6
    },
    "facebook":     {
      "png": _temp7
    },
    "instagram":     {
      "png": _temp8
    },
    "logodry":     {
      "png": _temp9
    },
    "twitter":     {
      "png": _temp10
    },
    "youtube":     {
      "png": _temp11
    }
  },
  "payment-method":   {
    "9":     {
      "png": _temp12
    },
    "10":     {
      "png": _temp13
    },
    "11":     {
      "png": _temp14
    },
    "13":     {
      "png": _temp15
    },
    "15":     {
      "png": _temp16
    },
    "17":     {
      "png": _temp17
    },
    "18":     {
      "png": _temp18
    },
    "19":     {
      "png": _temp19
    },
    "20":     {
      "png": _temp20
    },
    "21":     {
      "png": _temp21
    },
    "23":     {
      "png": _temp22
    },
    "amazon":     {
      "png": _temp23
    },
    "amex":     {
      "png": _temp24
    },
    "default":     {
      "png": _temp25
    },
    "diners":     {
      "png": _temp26
    },
    "discover":     {
      "png": _temp27
    },
    "jcb":     {
      "png": _temp28
    },
    "maestro":     {
      "png": _temp29
    },
    "mastercard":     {
      "png": _temp30
    },
    "paypal":     {
      "png": _temp31
    },
    "skrill":     {
      "png": _temp32
    },
    "visa":     {
      "png": _temp33
    },
    "westerunion":     {
      "png": _temp34
    },
    "worlpay":     {
      "png": _temp35
    }
  }
}